// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestCircle {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }


    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** 绘制 */
        // const ellipse1 = new vf.gui.Ellipse();
        // ellipse1.lineType = "full";
        // ellipse1.x = 200;
        // ellipse1.y = 300;
        // ellipse1.lineColor = 0x00ffcc;
        // ellipse1.lineWidth = 3;
        // ellipse1.width = 500;
        // ellipse1.height = 300;
        // uiStage.addChild(ellipse1);

        const ellipse = new vf.gui.Ellipse();
        ellipse.lineType = "full";
        ellipse.x = 200;
        ellipse.y = 300;
        ellipse.lineColor = 0xff00cc;
        ellipse.lineWidth = 3;
        ellipse.width = 500;
        ellipse.height = 300;
        uiStage.addChild(ellipse);

        const b = new vf.gui.Graphics();
        const a = b.graphics;
        a.lineStyle(2, 0xff0000, 1, 0, false);
        a.moveTo(0, 200);
        a.bezierCurveTo(10, 40, 30, 18, 300, 0);
        b.style.left = 400;
        b.style.top = 300;
        uiStage.addChild(b);


        const bb = new vf.gui.Graphics();
        const aa = bb.graphics;
        aa.lineStyle(2, 0x00ff00, 1, 0, false, "dash");
        aa.moveTo(0, 200);
        aa.bezierCurveTo(10, 40, 30, 18, 300, 0);

        bb.style.left = 400;
        bb.style.top = 300;
        uiStage.addChild(bb);


        this.getButton('设置/取消scale', () => {
            if (ellipse.scaleX !== 2) {
                ellipse.scaleX = 2;
                ellipse.scaleY = 2;
            } else {
                ellipse.scaleX = 1;
                ellipse.scaleY = 1;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 fill', () => {
            if (ellipse.color === undefined) {
                ellipse.color = 0xff00ff;
            } else {
                ellipse.color = undefined;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消width\\/height', () => {
            if (ellipse.width === 100) {
                ellipse.width = 300;
                ellipse.height = 200;
            } else {
                ellipse.width = 100;
                ellipse.height = 100;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 虚线(虚线不能填充)', () => {
            if (ellipse.lineType === "full") {
                ellipse.lineType = "dash";
            } else {
                ellipse.lineType = "full";
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 fillColor', () => {
            if (ellipse.style.fillGradientType !== 1) {
                ellipse.style.fillGradientType = 1
                ellipse.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                ellipse.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];
            } else {
                ellipse.style.fillGradientType = 0
                ellipse.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                ellipse.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];
            }

        }, uiStage, 650, 0);

    }

    private posY = 15;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
    }
}

